import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';

import { SelectField, Option } from '@johnlewispartnership/wtr-ingredients/ingredients/Forms';

import { titles } from 'components/Address/util';

const TitleSelect = forwardRef(({ initialTitle = null }, ref) => {
  const { errors: validationErrors, control } = useFormContext();
  return (
    <Controller
      id="title-field-controller"
      name="title"
      control={control}
      defaultValue={initialTitle}
      rules={{ required: 'Please select a title' }}
      render={renderProps => (
        <SelectField
          autoComplete="honorific-prefix"
          id="title"
          label="Title"
          ref={ref}
          onChange={event => renderProps.onChange(event.target.value)}
          errorText={validationErrors.title?.message}
        >
          {titles.map(({ label, value }) => (
            <Option selected={initialTitle && initialTitle === value} key={value} value={value}>
              {label}
            </Option>
          ))}
        </SelectField>
      )}
    />
  );
});

TitleSelect.displayName = 'TitleSelect';

TitleSelect.propTypes = {
  initialTitle: PropTypes.string,
};

export default TitleSelect;
